module.exports = __webpack_public_path__ + "static/media/fourth_img.11856d16.png";